export default __webpack_public_path__ + "static/media/doggo.bbb603df.png";